//import * as actionTypes from '../../../Store/Actions/actionTypes';
import axios from '../../../Axios/axios';


export const POST_TDI = 'POST_TDI';
export const POST_TDI_RETURN = 'POST_TDI_RETURN';
export const POST_EN3_RETURN = 'POST_EN3_RETURN';





export const execute_postTdi = (endPoint,sessionId) => {
    var transfertObject = {
        FLAG:null,
        ObjDataDto:null,
        ObjDatasCibleDto:null,
        ObjDatasSourceDto:null,
        ObjParamDto:null,
        ObjParamsDto:{
            CD:null,
            DestroyCol:0,
            LNH:null,
            RecordFlag:null,
            SV:0,
            SessionIDE:"",
            ToIUD:0
        },
        Session:{
            Application:null,
            CodeApplication:4,
            Session:null
        },
        objFile:null,
        vntIndexKey:0
    };
    transfertObject.ObjParamsDto.SessionIDE = sessionId;
    return (dispatch) => {
        axios.ArcsAxios.post(endPoint, transfertObject)
            .then(response => {
                dispatch(postTDI_data_Return(response));
            })
            .catch(error => {
                console.log("Error");
                console.log(error);
            })
    }
}

export const execute_postEN3 =(endPoint, sessionId)=>{

    var tmpSession = {
        FLAG:null,
        ObjDataDto:null,
        ObjDatasCibleDto:null,
        ObjDatasSourceDto:null,
        ObjParamDto:null,
        ObjParamsDto:{
            ARCS_PER:0,
            ARCS_TP_N3:0,
            CD:null,
            CODE:null,
            DestroyCol:0,
            LNH:null,
            RecordFlag:null,
            SV:0,
            SessionIDE:sessionId,
            ToIUD:0
        },
        Session:{
            Application:null,
            CodeApplication:4,
            Session:null
        },
        objFile:null,
        vntIndexKey:0
    };
    return (dispatch) => {
        axios.ArcsAxios.post(endPoint, tmpSession)
            .then(response => {
                dispatch(postEN3_data_Return(response));
            })
            .catch(error => {
                console.log("Error");
                console.log(error);
            })
    }
}

const postTDI_data_Return = (response) => {
    var TDIList = response.data;
    return {
        type: POST_TDI_RETURN,
        data: TDIList
    }

}

const postEN3_data_Return = (response) => {
    var EN3List = response.data;
    return {
        type: POST_EN3_RETURN,
        data: EN3List
    }
}


// const postTDI = (response, session) => {
//     return {
//         type: POST_TDI,
//         data: { session: session, response: response }
//     }
// }

    
// TDIList.forEach(element => {
    //     var tmpSession = {
    //         FLAG:null,
    //         ObjDataDto:null,
    //         ObjDatasCibleDto:null,
    //         ObjDatasSourceDto:null,
    //         ObjParamDto:null,
    //         ObjParamsDto:{
    //             ARCS_PER:0,
    //             ARCS_TP_N3:element.ARCS,
    //             CD:null,
    //             CODE:null,
    //             DestroyCol:0,
    //             LNH:null,
    //             RecordFlag:null,
    //             SV:0,
    //             SessionIDE:sessionId,
    //             ToIUD:0
    //         },
    //         Session:{
    //             Application:null,
    //             CodeApplication:4,
    //             Session:null
    //         },
    //         objFile:null,
    //         vntIndexKey:0
    //     };
    //     axios.ArcsAxios.post("WCFWindowsArcs/EN3ECLoad", tmpSession)
    //     .then(response => {
    //         console.log("RETURN EN3",response);
    //         //item.childs = response.data;
    //     })
    //     .catch(error => {
    //         console.log("Error");
    //         console.log(error);
    //     })
    // });